import { render } from "./FavouriteToggle.vue?vue&type=template&id=3692e29d&scoped=true"
import script from "./FavouriteToggle.vue?vue&type=script&lang=js"
export * from "./FavouriteToggle.vue?vue&type=script&lang=js"

import "./FavouriteToggle.vue?vue&type=style&index=0&id=3692e29d&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3692e29d"]])

export default __exports__